require('./index.jade')
moment = require('moment')
$ = require('jquery')

GroupMemberDirective = ($filter ,$translate ) ->
  restrict: "EA"
  replace: true
  templateUrl: "group-member/group-mem-directive/index.jade"
  scope:
    data: '=data'
    userid: '=userId'
  link: (scope) ->
    scope.displayName = (fName , lName) ->
      fName = fName ? ''
      lName = lName ? ''
      if fName + lName == ''
        return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED')
      if /^ja/i.test $translate.preferredLanguage()
        return lName + " " + fName
      return fName + " " + lName
    scope.displayTimeAgo = (time) ->
      if time is undefined
        return ""

      if /^ja/i.test $translate.preferredLanguage()
        moment.locale('ja')

      timeAgoMess = $filter('translate')('_GROUP_MEMBERS.TIME_AGO')
      timeAgo = moment(time)
      timeAgoText = timeAgo.fromNow()
      $filter('formatString')(timeAgoMess , timeAgoText)

    scope.getTextOfAvatar = ->
      $avatarElement = $(".avatar-for-#{scope.data.id} .avatar-image-text:not(.is-small)")

      if scope.data.display_text_avatar.length == 1
        $avatarElement.removeClass('two-characters')
        $avatarElement.addClass('one-character')
      else
        $avatarElement.removeClass('one-character')
        $avatarElement.addClass('two-characters')
      scope.data.display_text_avatar

    scope.isAvatarColor = ->
      scope.data.avatar_image_path?.indexOf('avatar_color') > -1

GroupMemberDirective.$inject = [
  '$filter'
  '$translate'
]

module.exports = GroupMemberDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-member/group-mem-directive/group-mem-directive.coffee